import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'ui-event-group-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div class="flex flex-col justify-start items-start">
        <span class="text-black"> {{ t(type()) }} </span>
        <span class="text-neutral-7"> {{ t(group()) }} </span>
      </div>
    </ng-container>
  `,
})
export class EventGroupIndicatorComponent {
  group = input.required<string>();
  type = input.required<string>();
}
